<template>
  <div>
    <el-card class="box-card" v-if="showchart">
        <div class="title">采集数据趋势图</div>
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="71px" class="mt20">
            <el-form-item label="佩戴时间">
              <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
              <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="clicksearch">查询</el-button>
                <el-button type="info" @click="backTrainingDataAnalysis">返回</el-button>
            </el-form-item>
        </el-form>
        <ve-candle
        :data="candleData"
        :settings="candleSettings"></ve-candle>

        <div class="title mt20">低峰高峰</div>
        <el-table :data="dataList" border stripe class="mt15">
            <el-table-column prop="FirstUpperLimit" label="低峰区间">
              <template slot-scope="scope">
                <span style="color: #e95d4e;font-weight: 700;">{{ scope.row.FirstUpperLimit }},{{ scope.row.FirstLowerLimit }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="FirstCaijitimep" label="低峰时间"></el-table-column>
            <el-table-column prop="LastUpperLimit" label="高峰区间">
              <template slot-scope="scope">
                <span style="color: #e95d4e;font-weight: 700;">{{ scope.row.LastUpperLimit }},{{ scope.row.LastLowerLimit }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="LastCaijitimep" label="高峰时间"></el-table-column>
            <el-table-column prop="AfterNum" label="区间变化数量"></el-table-column>
            <el-table-column prop="AfterDays" label="所耗天数"></el-table-column>
        </el-table>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    this.candleSettings = {
      showMA: false,
      showVol: true,
      showDataZoom: true,
      labelMap: {
        '日K': '采集数据趋势图',
        'open': '区间上限',
        'close': '区间下限',
        'lowest': '当前左眼屈光度',
        'highest': '当前右眼屈光度',
        'Volume': '速度',
      },
      dataType: 'normal',
      start: 30,
      end: 70,
      downColor: '#56b3ee',
      upColor: '#56b3ee'
    }
    return {
      keywords: {
        begintime: '',
        endtime: ''
      },
      chartData: {
        columns: ['统计日期', '佩戴总时长'],
        rows: []
      },
      candleData: {
        columns: ['日期', 'open', 'close', 'lowest', 'highest', 'vol'],
        rows: []
      },
      dataList: [],
      showchart: false,
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.showchart = true
      this.apiGetCaiJiTrend()
    },
    backTrainingDataAnalysis () {
      this.showchart = false
      this.$emit('triggerFunc', '')
    },
    clicksearch () {
      this.apiGetCaiJiTrend()
    },
    apiGetCaiJiTrend: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetCaiJiTrend, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.candleData.rows = []
            response.data.List.filter((item1, i1) => {
              that.candleData.rows.push({ '日期': item1.Caijitimep, open: item1.UpperLimit, close: item1.LowerLimit, lowest: item1.LeftDegree, highest: item1.LeftDegree, vol: item1.Speed })
            })
            that.dataList = response.data.LowHighList
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
